<template>
  <indicator v-if="count > 0">
    <alert2-icon
      :level="level"
      :size="size"
      :content="content"
    />
  </indicator>
</template>

<script>
import trans from '@utils/trans';
import api from '@services/api';
import Indicator from '../Indicator/Indicator.vue';
import Alert2Icon from '../../../../icons/Alert2/Alert2Icon.vue';

export default {
  components: {
    Alert2Icon,
    Indicator,
  },
  props: {
    deviceId: {
      required: false,
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: '24px',
    },
  },
  data() {
    return {
      level: null,
      count: null,
    };
  },
  computed: {
    content() {
      return `${trans('device.indicator.alert-level')} ${this.level}, ${trans('device.indicator.alert-count')} (${this.count})`;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const url = this.deviceId ? `/device/${this.deviceId}/alarms/stats` : '/alarms/stats';
      api.get(url)
        .then(
          (response) => {
            const { level, count } = response.data;
            this.level = level;
            this.count = count;
          },
        );
    },

  },
};
</script>
